import { NavItem } from '../full/vertical/sidebar/nav-item/nav-item';

// ============================================================================
//  Módulo de Farmacia (POS estilo SICAR) — bloques de menú componibles.
//
//  Cada grupo representa un ÁREA FUNCIONAL que eventualmente se asignará a un
//  rol específico (cajero, compras, crédito, almacén, gerencia). Los menús de
//  cada rol se arman importando solo los bloques que le correspondan, en lugar
//  de duplicar items. Por ahora Administrator y PharmacyManager ven todo.
//
//  Máximo 2 niveles (grupo → item) para compatibilidad con el layout horizontal.
// ============================================================================

// --- Caja (apertura / cierre / arqueo) --------------------------------------
export const pharmacyCaja: NavItem = {
  displayName: 'Caja',
  iconName: 'cash',
  route: '/farmacia/caja',
};

// --- Punto de venta (operación del mostrador) -------------------------------
export const pharmacyPuntoDeVenta: NavItem = {
  displayName: 'Punto de venta',
  iconName: 'shopping-cart',
  route: 'pos',
  children: [
    { displayName: 'Nueva venta', iconName: 'point', route: '/farmacia/ventas' },
    { displayName: 'Cotizaciones', iconName: 'point', route: '/farmacia/cotizaciones' },
    { displayName: 'Ventas / Historial', iconName: 'point', route: '/farmacia/ventas-totales' },
    { displayName: 'Devoluciones de venta', iconName: 'point', route: '/farmacia/devoluciones-venta' },
  ],
};

// --- Clientes y crédito (cartera por cobrar) --------------------------------
export const pharmacyClientes: NavItem = {
  displayName: 'Clientes y crédito',
  iconName: 'users',
  route: 'clientes-credito',
  children: [
    { displayName: 'Clientes', iconName: 'point', route: '/farmacia/clientes' },
    { displayName: 'Cuentas por cobrar', iconName: 'point', route: '/farmacia/cuentas-por-cobrar' },
  ],
};

// --- Inventario (existencias, lotes, traspasos, kardex) ---------------------
export const pharmacyInventario: NavItem = {
  displayName: 'Inventario',
  iconName: 'building-warehouse',
  route: 'inventario-farmacia',
  children: [
    { displayName: 'Productos', iconName: 'point', route: '/inventario/productos' },
    { displayName: 'Lotes y caducidades', iconName: 'point', route: '/inventario/lotes' },
    { displayName: 'Traspasos', iconName: 'point', route: '/inventario/traspasos' },
    { displayName: 'Kardex', iconName: 'point', route: '/inventario/kardex' },
  ],
};

// --- Compras de farmacia (Orden → Recepción → CxP). Las de almacén: warehouse.menu
// CxP es una sola para ambas bodegas (filtrable por bodega).
export const pharmacyCompras: NavItem = {
  displayName: 'Compras',
  iconName: 'truck-delivery',
  route: 'compras',
  children: [
    { displayName: 'Órdenes por autorizar', iconName: 'point', route: '/farmacia/ordenes-por-autorizar' },
    { displayName: 'Órdenes de compra', iconName: 'point', route: '/farmacia/ordenes-de-compra' },
    { displayName: 'Recepciones', iconName: 'point', route: '/farmacia/recepciones' },
    { displayName: 'Devoluciones a proveedor', iconName: 'point', route: '/farmacia/devoluciones-a-proveedor' },
    { displayName: 'Cuentas por pagar', iconName: 'point', route: '/farmacia/cuentas-por-pagar' },
  ],
};

// --- Comparador de proveedores (cotizaciones → mejor precio → sugerencias) ---
export const pharmacyComparador: NavItem = {
  displayName: 'Comparador',
  iconName: 'scale',
  route: 'comparador-proveedores',
  children: [
    { displayName: 'Comparador de precios', iconName: 'point', route: '/farmacia/comparador' },
    { displayName: 'Precios de proveedor', iconName: 'point', route: '/farmacia/precios-proveedor' },
    { displayName: 'Sugerencias de compra', iconName: 'point', route: '/farmacia/sugerencias-compra' },
    { displayName: 'Proveedores', iconName: 'point', route: '/administracion/proveedores' },
  ],
};

// --- Reportes / análisis (gerencia) -----------------------------------------
export const pharmacyReportes: NavItem = {
  displayName: 'Reportes',
  iconName: 'chart-bar',
  route: '/farmacia/reportes',
};

// Conjunto completo de grupos del módulo, en orden de flujo operativo.
// Reutilizable por cualquier rol que deba ver el módulo completo.
export const pharmacyMenuGroups: NavItem[] = [
  pharmacyCaja,
  pharmacyPuntoDeVenta,
  pharmacyClientes,
  pharmacyInventario,
  pharmacyCompras,
  pharmacyComparador,
  pharmacyReportes,
];

// Menú del rol PharmacyManager: módulo completo organizado por secciones.
export const navItemsFarmacy: NavItem[] = [
  { navCap: 'Operación' },
  pharmacyCaja,
  pharmacyPuntoDeVenta,

  { navCap: 'Inventario y compras' },
  pharmacyInventario,
  pharmacyCompras,
  pharmacyComparador,

  { navCap: 'Clientes' },
  pharmacyClientes,

  { navCap: 'Análisis' },
  pharmacyReportes,
];
